import api from "./client";

import type { ApiResponse } from "#/types/api";
import type {
  AssistantApiMessage,
  AssistantChatResponse,
  AssistantConfig,
  AssistantExportRequest,
  AssistantExportResponse,
  AssistantModelsResponse,
  AssistantTone,
  ClientAssistantOverview,
  UpdateClientAssistantPayload,
  UpdateUserAssistantPayload,
} from "#/types/assistant";

export const assistantApi = {
  // End-user
  getConfig: (): Promise<ApiResponse<AssistantConfig>> =>
    api.get("/assistant/config"),
  chat: (body: {
    messages: AssistantApiMessage[];
    tone?: AssistantTone;
  }): Promise<ApiResponse<AssistantChatResponse>> =>
    api.post("/assistant/chat", body),
  exportData: (
    body: AssistantExportRequest
  ): Promise<ApiResponse<AssistantExportResponse>> =>
    api.post("/assistant/export", body),

  // Admin
  getModels: (): Promise<ApiResponse<AssistantModelsResponse>> =>
    api.get("/assistant/admin/models"),
  getClientOverview: (
    clientId: number
  ): Promise<ApiResponse<ClientAssistantOverview>> =>
    api.get(`/assistant/admin/clients/${clientId}/overview`),
  updateClientSetting: (
    clientId: number,
    body: UpdateClientAssistantPayload
  ): Promise<ApiResponse<unknown>> =>
    api.patch(`/assistant/admin/clients/${clientId}/settings`, body),
  updateUserSetting: (
    userId: number,
    body: UpdateUserAssistantPayload
  ): Promise<ApiResponse<unknown>> =>
    api.patch(`/assistant/admin/users/${userId}/settings`, body),
};
